import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertToTime, getIsRTL } from "../util";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  Button,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { IS_MOBILE, translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import TextTicker from "react-native-text-ticker";
import {
  faBackward,
  faForward,
  faLink,
  faListMusic,
  faMinus,
  faPause,
  faPlay,
  faPlus,
  faSignIn,
  faTimes,
  faTrashAlt,
  faVolume,
  faVolumeMute,
  faWrench,
} from "../../assets/consts/faCharCodes";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { MULTI_MEDIA_STATE } from "../../assets/consts";
import { Collapse, HStack, IconButton, VStack } from "native-base";
import AddZoneSpeaker from "../components_v2/SmartSpeaker/AddZoneSpeaker";

import SliderBase from "../nativeBase-ui/SliderBase";
import axios from "axios";

// const QUICK_FORWARD = 30;

/**@augments {Component<props,state>} */
class SlaveSpeaker extends Component {
  static propTypes = {
    isMaster: PropTypes.bool,
    SpeakerName: PropTypes.string,
    volume: PropTypes.number,
    onRemovePress: PropTypes.func,
    onVolumeChange: PropTypes.func,
    isMuted: PropTypes.bool,
    onToggleMute: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      volume: this.props.volume || 0,
      isMuted: this.props.isMuted || false,
      lastVolume: this.props.volume || 0,
      showSlider: false,
      lastTimeVolumeChange: undefined,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    var nextState = { ...prevState };
    if (nextProps.volume != prevState.volume) {
      nextState.volume = nextProps.volume;
      nextState.lastVolume = nextProps.volume;
    }
    return nextState;
  }

  render() {
    return (
      <HStack
        w={{ md: "48%" }}
        p="8px"
        backgroundColor={Theme.COLORS.WHITE}
        rounded="xl"
        space={2}
        alignItems="center"
        mt="2"
        justifyContent="space-between"
      >
        <VolumeSlider
          volume={this.state.volume}
          isMuted={this.state.isMuted}
          onVolumeChange={(v) => {
            this.setState({ volume: v }, () => {
              typeof this.props.onVolumeChange === "function" &&
                this.props.onVolumeChange(v);
            });
          }}
        />
        {/* === Mute === */}
        <TouchableOpacity
          style={[
            styles.listButton,
            {
              backgroundColor: !this.state.isMuted
                ? "transparent"
                : Theme.COLORS.BACKGROUND,
            },
          ]}
          onPress={() => {
            this.setState({ isMuted: true }, () => {
              typeof this.props.onToggleMute === "function" &&
                this.props.onToggleMute(true);
            });
          }}
        >
          <FontAwesomeIcon
            icon={faVolumeMute}
            size={16}
            lite
            color={
              !this.state.isMuted ? Theme.COLORS.BLACK : Theme.COLORS.ERROR
            }
          />
        </TouchableOpacity>
        {/* === UnMute === */}
        <TouchableOpacity
          style={[
            styles.listButton,
            {
              backgroundColor: this.state.isMuted
                ? "transparent"
                : Theme.COLORS.BACKGROUND,
            },
          ]}
          onPress={() => {
            this.setState({ isMuted: false }, () => {
              typeof this.props.onToggleMute === "function" &&
                this.props.onToggleMute(false);
            });
          }}
        >
          <FontAwesomeIcon
            icon={faVolume}
            size={16}
            lite
            color={
              this.state.isMuted ? Theme.COLORS.BLACK : Theme.COLORS.ACTIVE
            }
          />
        </TouchableOpacity>
        <HStack
          space={2}
          alignItems="center"
          justifyContent="flex-end"
          flex={1}
        >
          {/* === device Name === */}
          <Text style={{ fontSize: 10, maxWidth: "50%" }}>
            {this.props.SpeakerName}
          </Text>
          {/* === MASTER text === */}
          {this.props.isMaster && (
            <View
              style={{
                height: 40,
                minWidth: 40,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: Theme.COLORS.PRIMARY_DARK + "15",
                borderRadius: 10,
                padding: 1,
              }}
            >
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                }}
              >
                MASTER
              </Text>
            </View>
          )}
          {/* === Remove === */}
          {!this.props.isMaster && (
            <IconButton
              alignSelf="center"
              colorScheme="error"
              variant="solid"
              style={styles.btnRemove}
              onPress={() => {
                typeof this.props.onRemovePress === "function" &&
                  this.props.onRemovePress();
              }}
              icon={
                <FontAwesomeIcon
                  // icon={removeIsLoading ? <Spinner /> : faTrashAlt}
                  icon={faTrashAlt}
                  size={16}
                  color={Theme.COLORS.ERROR}
                />
              }
            />
          )}
        </HStack>
      </HStack>
    );
  }
}

/**@augments {Component<props,state>} */
class VolumeSlider extends Component {
  static propTypes = {
    volume: PropTypes.number,
    onVolumeChange: PropTypes.func,
    isMuted: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      volume: this.props.volume || 0,
      lastVolume: this.props.volume || 0,
      lastTimeVolumeChange: undefined,
      isChanging: false,
      showVolumeSlider: false,
    };
  }
  autoHideSlider() {
    setTimeout(() => {
      if (
        this.state.lastTimeVolumeChange &&
        new Date().getTime() - this.state.lastTimeVolumeChange.getTime() >= 3500
      ) {
        this.setState({
          showVolumeSlider: false,
          lastTimeVolumeChange: undefined,
        });
      }
    }, 4000);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.volume >= 0 && nextProps.volume != prevState.volume) {
      var nextState = { ...prevState };
      nextState.volume = nextProps.volume;
      return nextState;
    }
    return null;
  }

  render() {
    if (this.state.showVolumeSlider) {
      return (
        <>
          <Text style={{ color: Theme.COLORS.ACTIVE, paddingHorizontal: 10 }}>
            {this.state.lastVolume}
          </Text>
          <SliderBase
            style={[styles.slider, { backgroundColor: "#fff8" }]}
            // defaultValue={this.state.volume}
            defaultValue={this.state.volume}
            minValue={0}
            maxValue={100}
            step={1}
            onChange={(v) => {
              var firstChange = this.state.lastTimeVolumeChange == undefined;
              this.setState(
                {
                  lastVolume: v,
                  lastTimeVolumeChange: new Date(),
                  isChanging: true,
                },
                () => {
                  if (v % 5 == 0 || firstChange) this.autoHideSlider();
                }
              );
            }}
            onChangeEnd={(v) => {
              if (v == 0 || v == 100) {
                if (Math.abs(this.state.lastVolume - v > 10)) {
                  console.log("ignore jump volume");
                  return;
                }
              }
              if (v >= 0) {
                this.setState(
                  {
                    volume: v,
                    lastTimeVolumeChange: new Date(),
                    isChanging: false,
                  },
                  () => {
                    this.autoHideSlider();
                    typeof this.props.onVolumeChange === "function" &&
                      this.props.onVolumeChange(v);
                  }
                );
              }
            }}
          />
        </>
      );
    } else {
      return (
        <HStack
          justifyContent={Platform.OS == "web" ? "flex-end" : "flex-start"}
          flex={1}
        >
          <TouchableOpacity
            onPress={() => {
              var v = this.state.volume + 5;
              if (v > 100) v = 100;
              this.setState({ volume: v }, () => {
                typeof this.props.onVolumeChange === "function" &&
                  this.props.onVolumeChange(v);
              });
              // this.handleOnVolumeChange(
              //   v,
              //   this.props.smartSpeakerDeviceId,
              //   this.props.smartSpeakerDeviceUId,
              //   true
              // );
            }}
            style={styles.btnVolumePlus}
          >
            <HStack style={{ alignItems: "center" }}>
              <FontAwesomeIcon
                // icon={removeIsLoading ? <Spinner /> : faTrashAlt}
                icon={faPlus}
                size={16}
                color={
                  this.props.isMuted ? Theme.COLORS.ERROR : Theme.COLORS.ACTIVE
                }
              />
            </HStack>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              this.setState(
                {
                  showVolumeSlider: true,
                  lastTimeVolumeChange: new Date(),
                },
                () => {
                  this.autoHideSlider();
                }
              );
            }}
            style={{
              backgroundColor: Theme.COLORS.BACKGROUND,
              padding: 5,
              borderRadius: 5,
            }}
          >
            <HStack style={{ alignItems: "center" }}>
              {!this.props.isMuted && (
                <Text
                  style={{
                    color: this.props.isMuted
                      ? Theme.COLORS.ERROR
                      : Theme.COLORS.ACTIVE,
                  }}
                >
                  {" "}
                  {this.state.volume}{" "}
                </Text>
              )}
              <FontAwesomeIcon
                // icon={removeIsLoading ? <Spinner /> : faTrashAlt}
                icon={this.props.isMuted ? faVolumeMute : faVolume}
                size={16}
                color={
                  this.props.isMuted ? Theme.COLORS.ERROR : Theme.COLORS.ACTIVE
                }
              />
            </HStack>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              var v = this.state.volume - 5;
              if (v < 0) v = 0;
              this.setState({ volume: v }, () => {
                typeof this.props.onVolumeChange === "function" &&
                  this.props.onVolumeChange(v);
              });
              // this.handleOnVolumeChange(
              //   v,
              //   this.props.smartSpeakerDeviceId,
              //   this.props.smartSpeakerDeviceUId,
              //   true
              // );
            }}
            style={styles.btnVolumePlus}
          >
            <HStack style={{ alignItems: "center" }}>
              <FontAwesomeIcon
                // icon={removeIsLoading ? <Spinner /> : faTrashAlt}
                icon={faMinus}
                size={16}
                color={
                  this.props.isMuted ? Theme.COLORS.ERROR : Theme.COLORS.ACTIVE
                }
              />
            </HStack>
          </TouchableOpacity>
        </HStack>
      );
    }
  }
}

/**@augments {Component<props,state>} */
class SeekBar extends Component {
  static propTypes = {
    position: PropTypes.number,
    duration: PropTypes.number,
    playingState: PropTypes.number,
    onPositionChange: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentTime: this.props.position || 0,
      isSeeking: false,
      tempPosition: this.props.position || 0,
    };
  }
  componentDidMount() {
    this.startTimer();
  }
  startTimer = () => {
    setTimeout(() => {
      if (
        this.props.playingState == MULTI_MEDIA_STATE.playing &&
        this.state.currentTime < this.props.duration + 1 &&
        !this.state.isSeeking
      ) {
        var t = this.state.currentTime + 1;
        this.setState(
          {
            currentTime: t,
          },
          () => {
            typeof this.props.onPositionChange === "function" &&
              this.props.onPositionChange(t, false);
            this.startTimer();
          }
        );
      } else {
        this.startTimer();
      }
    }, 1000);
  };

  render() {
    return (
      <View style={{ height: 40 }}>
        <SliderBase
          size="lg"
          style={[styles.slider, { backgroundColor: "#fff8" }]}
          defaultValue={this.state.currentTime}
          value={this.state.currentTime}
          minValue={0}
          maxValue={this.props.duration || 0}
          step={1}
          onChange={(v) => {
            v >= 0 &&
              this.setState({
                currentTime: v,
                isSeeking: true,
              });
          }}
          onChangeEnd={(v) =>
            v >= 0 &&
            this.setState({ currentTime: v, isSeeking: false }, () => {
              typeof this.props.onPositionChange === "function" &&
                this.props.onPositionChange(v, true);
            })
          }
        />

        <View
          style={{
            marginTop: 20,
            width: "100%",
            flexDirection: getIsRTL() ? "row-reverse" : "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text style={[styles.time, { color: Theme.COLORS.MUTED }]}>
            {convertToTime(
              this.state.isSeeking
                ? this.state.tempPosition
                : this.state.currentTime
            )}
          </Text>
          {/* <Text style={styles.time}> / </Text> */}
          <Text style={styles.time}>
            {convertToTime(this.props.duration || 0)}
          </Text>
        </View>
      </View>
    );
  }
}

/**@augments {Component<props,state>} */
class MediaPlayer extends Component {
  static propTypes = {
    smartSpeakerDeviceId: PropTypes.number.isRequired,
    smartSpeakerDeviceName: PropTypes.string.isRequired,
    playListId: PropTypes.number,
    playListName: PropTypes.string,
    trackId: PropTypes.string,
    trackName: PropTypes.string,
    trackDuration: PropTypes.number,
    currentTime: PropTypes.number,
    playingState: PropTypes.number,
    volume: PropTypes.number,
    lastVolume: PropTypes.number,
    isMuted: PropTypes.bool,
    input: PropTypes.string,
    style: PropTypes.shape(),
    onClose: PropTypes.func,
    onPlay: PropTypes.func,
    onResume: PropTypes.func,
    onPause: PropTypes.func,
    onSeek: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    onList: PropTypes.func,
    onVolumeChange: PropTypes.func,
    onToggleMute: PropTypes.func,
    onToggleSlaveMute: PropTypes.func,
    onInit: PropTypes.func,
    onInputChange: PropTypes.func,
    onResetCurrentTimePosition: PropTypes.func,
    slavesList: PropTypes.arrayOf(PropTypes.string),
  };

  constructor(props) {
    super(props);
    this.state = {
      currentTime: undefined,
      tempCurrentTime: 0,
      isSeeking: false,
      isMuted: this.props.isMuted || false,
      // volume: this.props.volume || 0,
      volume: undefined,
      lastVolume: undefined,
      playingState: this.props.playingState || MULTI_MEDIA_STATE.stopped,
      currentTrackId: this.props.trackId,
      showSpeakerGroupsCollapse: false,
      showInputMenu: false,
      lastTimeVolumeChange: undefined,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    var nextState = { ...prevState };
    if (nextProps.trackId != prevState.currentTrackId) {
      nextState.currentTime = 0;
      nextState.tempCurrentTime = 0;
      nextState.currentTrackId = nextProps.trackId;
    }
    if (nextProps.currentTime > 0) {
      // console.log(
      //   "nextProps.currentTime to change seek bar",
      //   nextProps.currentTime
      // );
      nextState.currentTime = nextProps.currentTime;
      typeof nextProps.onResetCurrentTimePosition === "function" &&
        nextProps.onResetCurrentTimePosition();
    }
    if (prevState.currentTime === undefined) {
      nextState.currentTime = nextProps.currentTime;
    }
    if (
      prevState.volume === undefined ||
      prevState.volume != nextProps.volume
    ) {
      nextState.volume = nextProps.volume;
    }
    return nextState;
  }

  componentDidMount() {
    //this.startTimer();
    this.handleOnInit();
  }

  handleOnInit() {
    typeof this.props.onInit === "function" &&
      setTimeout(() => {
        this.props.onInit();
      }, 400);
  }

  handleOnClose() {
    this.setState({ playingState: MULTI_MEDIA_STATE.stopped });
    typeof this.props.onClose === "function" && this.props.onClose();
  }

  handleOnPlay() {
    this.setState({ playingState: MULTI_MEDIA_STATE.playing });
    typeof this.props.onPlay === "function" && this.props.onPlay();
  }

  handleOnResume() {
    this.setState({ playingState: MULTI_MEDIA_STATE.playing });
    typeof this.props.onResume === "function" && this.props.onResume();
  }

  handleOnPause() {
    this.setState({ playingState: MULTI_MEDIA_STATE.paused });
    typeof this.props.onPause === "function" && this.props.onPause();
  }

  handleOnSeek(targetPosition) {
    typeof this.props.onSeek === "function" &&
      this.props.onSeek(targetPosition);
  }

  handleOnNext() {
    typeof this.props.onNext === "function" && this.props.onNext();
  }

  handleOnPrevious() {
    typeof this.props.onPrevious === "function" && this.props.onPrevious();
  }

  handleOnList() {
    typeof this.props.onList === "function" && this.props.onList();
  }

  handleOnVolumeChange(volume, deviceId, deviceUId, group = false) {
    group && this.setState({ volume });
    typeof this.props.onVolumeChange === "function" &&
      this.props.onVolumeChange(volume, deviceId, deviceUId, group);

    this.props.isMuted === true && this.handleOnToggleMute(false, group);
  }

  handleOnToggleMute(muted = false, group = false) {
    this.setState({ isMuted: muted });

    typeof this.props.onToggleMute === "function" &&
      this.props.onToggleMute(muted, group);
  }

  handleOnInputChange(input = "wifi") {
    this.setState({ showInputMenu: false });
    typeof this.props.onInputChange === "function" &&
      this.props.onInputChange(input);
  }

  toggleSpeakerGroupsCollapse = () => {
    this.setState({
      showSpeakerGroupsCollapse: !this.state.showSpeakerGroupsCollapse,
    });
  };
  renderSlavesGroup = () => {
    // const speakers = [...this.props.allSpeakers].filter((speaker) =>
    //   (this.props.slavesList || []).some((slave) => slave === speaker.deviceUId)
    // );

    var speakers = [];
    var master = this.props.allSpeakers.find(
      (s) => s.deviceUId == this.props.smartSpeakerDeviceUId
    );
    if (master) {
      var slaves = this.props.allSpeakers.filter((s) => {
        return (
          Array.isArray(master.slavesList) &&
          master.slavesList.includes(s.deviceUId)
        );
      });

      if (slaves.length > 0) {
        speakers = [master, ...slaves].map((s) => {
          return {
            isMaster: s.deviceUId == this.props.smartSpeakerDeviceUId,
            SpeakerName: s.deviceName,
            volume: s.volume,
            isMuted: s.isMuted,
            deviceUId: s.deviceUId,
            deviceId: s.deviceId,
          };
        });
        // .sort((a, b) =>
        //   a.isMaster > b.isMaster ? 1 : a.SpeakerName > b.SpeakerName ? 1 : 0
        // );
      }
    }

    const onSubmitAddSlaveHandler = async (slaveDeviceUId) => {
      const model = {
        areaId: this.props.areaId,
        areaUId: this.props.areaUId,
        buildingId: this.props.buildingId,
        masterDeviceUId: this.props.smartSpeakerDeviceUId,
        slaveDeviceUId,
      };

      try {
        var _serverUrl = this.props.serverUrl;
        if (!_serverUrl?.endsWith("/")) {
          _serverUrl += "/";
        }

        const response = await axios.post(
          `${_serverUrl}SmartSpeakers/AddGroup`,
          model,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.props.accessToken}`,
            },
          }
        );
        if (response?.data?.result) {
          this.props.onUpdateSlaveSmartSpeakerLocal(
            response.data.masterDeviceUId,
            response.data.slaveDeviceUId,
            "ADD"
          );
        }
      } catch (error) {
      } finally {
        // setRemoveIsLoading(false);
      }
    };
    return (
      <View style={{ paddingHorizontal: 5 }}>
        <HStack
          space="2"
          flexDirection={{ md: "column", md: "row-reverse" }}
          justifyContent="space-between"
          style={{ marginBottom: 10 }}
        >
          {speakers.map((speaker, s) => {
            return (
              <SlaveSpeaker
                key={s}
                isMaster={speaker.isMaster}
                SpeakerName={speaker.SpeakerName}
                volume={speaker.volume}
                onVolumeChange={(v) => {
                  v >= 0 &&
                    this.handleOnVolumeChange(
                      v,
                      speaker.deviceId,
                      speaker.deviceUId,
                      false
                    );
                }}
                isMuted={speaker.isMuted}
                onToggleMute={(_mute) => {
                  typeof this.props.onToggleSlaveMute === "function" &&
                    this.props.onToggleSlaveMute(
                      speaker.deviceUId,
                      speaker.deviceId,
                      _mute
                    );
                }}
                onRemovePress={async () => {
                  const model = {
                    areaId: this.props.areaId,
                    areaUId: this.props.areaUId,
                    buildingId: this.props.buildingId,
                    masterDeviceUId: this.props.smartSpeakerDeviceUId,
                    slaveDeviceUId: speaker.deviceUId,
                  };

                  try {
                    var _serverUrl = this.props.serverUrl;
                    if (!_serverUrl?.endsWith("/")) {
                      _serverUrl += "/";
                    }

                    const response = await axios.post(
                      `${_serverUrl}SmartSpeakers/RemoveGroup`,
                      model,
                      {
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${this.props.accessToken}`,
                        },
                      }
                    );
                    if (response?.data?.result) {
                      this.props.onUpdateSlaveSmartSpeakerLocal(
                        response.data.masterDeviceUId,
                        response.data.slaveDeviceUId,
                        "DELETE"
                      );
                    }
                  } catch (error) {
                    console.log(
                      "error remove Slave Smart Speaker Handler",
                      error
                    );
                  }
                }}
              />
            );
          })}
        </HStack>
        <Collapse isOpen={this.state.showSpeakerGroupsCollapse ? true : false}>
          <AddZoneSpeaker
            masterSmartSpeakerUId={this.props.smartSpeakerDeviceUId}
            allSpeakers={this.props.allSpeakers}
            slavesList={this.props.slavesList}
            onSubmit={(slaveDeviceUId) => {
              onSubmitAddSlaveHandler(slaveDeviceUId);
            }}
          />
        </Collapse>
      </View>
    );
  };
  renderMediaContent = () => {
    const RenderCoverImg = () => {
      var _serverUrl = this.props.serverUrl;
      if (!_serverUrl?.endsWith("/")) {
        _serverUrl += "/";
      }
      var inputMode = this.props.input;
      var coverImage = "";
      switch (this.props.input) {
        case "line-in":
        case "bluetooth":
        case "udisk":
        case "PCUSB":
          coverImage = `${_serverUrl}media/cover/${this.props.input}`;
          break;
        case "wifi":
        default:
          coverImage = `${_serverUrl}media/cover/${this.props.trackId}?buildingId=${this.props.buildingId}`;
          break;
      }
      return (
        <View
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 10,
            // resizeMode: "cover",
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "100%",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,

              // resizeMode: "cover",
            }}
            source={{ uri: coverImage }}
            alt="Tap Sound"
          />
          {!this.state.showInputMenu && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 5,
              }}
            >
              <Text>
                {this.props.input == "wifi" ? "Network" : this.props.input}
              </Text>
              <IconButton
                style={[
                  styles.btnChangeInput,
                  {
                    backgroundColor:
                      this.props.input == "bluetooth"
                        ? Theme.COLORS.INFO
                        : this.props.input == "line-in"
                        ? Theme.COLORS.SUCCESS
                        : Theme.COLORS.PRIMARY,
                  },
                ]}
                onPress={() => {
                  this.setState({ showInputMenu: true });
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faSignIn}
                    size={12}
                    color={Theme.COLORS.WHITE}
                  />
                }
              />
            </View>
          )}
          {this.state.showInputMenu && (
            <View style={styles.inputMenu}>
              <IconButton
                style={{
                  alignSelf: "flex-end",
                  marginBottom: 10,
                  width: 25,
                  height: 25,
                  backgroundColor: Theme.COLORS.ERROR,
                }}
                onPress={() => {
                  this.setState({ showInputMenu: false });
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faTimes}
                    size={12}
                    color={Theme.COLORS.WHITE}
                  />
                }
              />
              <TouchableOpacity
                style={[
                  styles.btnMenu,
                  this.props.input == "wifi"
                    ? { backgroundColor: Theme.COLORS.ACTIVE }
                    : undefined,
                ]}
                onPress={() => {
                  this.handleOnInputChange("wifi");
                }}
              >
                <Text>Network</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.btnMenu,
                  this.props.input == "line-in"
                    ? { backgroundColor: Theme.COLORS.ACTIVE }
                    : undefined,
                ]}
                title="network"
                onPress={() => {
                  this.handleOnInputChange("line-in");
                }}
              >
                <Text>Line-in</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.btnMenu,
                  this.props.input == "bluetooth"
                    ? { backgroundColor: Theme.COLORS.ACTIVE }
                    : undefined,
                ]}
                onPress={() => {
                  this.handleOnInputChange("bluetooth");
                }}
              >
                <Text>Bluetooth</Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      );
    };
    const RenderSeekBar = () => {
      return (
        <SeekBar
          duration={(this.props.trackDuration || 0) / 1000}
          position={this.state.currentTime || this.props.currentTime}
          playingState={this.props.playingState}
          onPositionChange={(v, force) => {
            this.setState({ currentTime: v }, () => {
              force && this.handleOnSeek(v, true);
            });
          }}
        />
      );
    };
    const RenderTitleBar = () => {
      return (
        <VStack style={{ marginBottom: 10, flex: 1, minHeight: 70 }}>
          <HStack
            style={{ marginBottom: 5 }}
            space="2"
            w="full"
            alignItems="center"
          >
            {/* close button */}
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => this.handleOnClose()}
            >
              <FontAwesomeIcon icon={faTimes} size={24} />
            </TouchableOpacity>
            {/* === deviceName === */}
            <Text style={{ fontWeight: "bold", fontSize: 14 }}>
              {this.props.smartSpeakerDeviceName}
            </Text>
          </HStack>
          {/* track name */}
          {Platform.OS === "web" ? (
            <TextTicker
              style={{
                textAlign: "center",
                flex: 1,
                color: Theme.COLORS.GRAY_DARK,
                fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
              }}
              duration={10000}
              shouldAnimateTreshold={40}
              loop
              repeatSpacer={50}
              marqueeDelay={1000}
            >
              {this.props.trackName}
            </TextTicker>
          ) : (
            <Text
              style={{
                textAlign: "center",
                flex: 1,
                color: Theme.COLORS.GRAY_DARK,
                // fontFamily: "IRANSansWebFaNum",
              }}
              numberOfLines={1}
              ellipsesMode="tail"
            >
              {this.props.trackName}
            </Text>
          )}
        </VStack>
      );
    };

    const RenderController = () => {
      return (
        <HStack
          style={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          {/* === List handler === */}
          <IconButton
            alignSelf="center"
            colorScheme="error"
            variant="solid"
            style={[styles.btn, styles.btnCog]}
            onPress={() => this.handleOnList()}
            icon={
              <FontAwesomeIcon
                icon={faListMusic}
                size={12}
                color={Theme.COLORS.PRIMARY}
              />
            }
          />
          <View
            style={[
              styles.container,
              styles.controlsContainer,
              {
                flexDirection: IS_MOBILE ? "row" : "row-reverse",
              },
            ]}
            // flexDirection={IS_MOBILE ? "row-reverse" : "row"}
          >
            {/* previous */}
            <TouchableOpacity
              style={{ alignItems: "center" }}
              onPress={() => this.handleOnPrevious()}
            >
              <FontAwesomeIcon
                icon={IS_MOBILE ? faForward : faBackward}
                size={22}
                color={Theme.COLORS.DARK}
                lite={true}
              />
              <Text style={{ fontSize: 10, marginTop: 3 }}>
                {translate("smartSpeaker.prev")}
              </Text>
            </TouchableOpacity>
            {/* play/pause */}
            <TouchableOpacity
              onPress={() => {
                if (this.props.playingState == MULTI_MEDIA_STATE.playing)
                  this.handleOnPause();
                else {
                  if (this.state.currentTime > 0) this.handleOnResume();
                  else this.handleOnPlay();
                }
              }}
            >
              <FontAwesomeIcon
                icon={
                  this.props.playingState == MULTI_MEDIA_STATE.playing
                    ? faPause
                    : faPlay
                }
                size={36}
                color={Theme.COLORS.DARK}
                lite={true}
              />
            </TouchableOpacity>
            {/* next */}
            <TouchableOpacity
              style={{ alignItems: "center" }}
              onPress={() => {
                this.handleOnNext();
              }}
            >
              <FontAwesomeIcon
                icon={IS_MOBILE ? faBackward : faForward}
                size={22}
                color={Theme.COLORS.DARK}
                lite={true}
              />
              <Text style={{ fontSize: 10, marginTop: 3 }}>
                {translate("smartSpeaker.next")}
              </Text>
            </TouchableOpacity>
          </View>
          {/* === todo: toggle group speakers === */}
          {!this.props.isKioskMode &&
          this.props?.allSpeakers?.length > 1 &&
          this.props?.allSpeakers?.length - this.props?.slavesList?.length !==
            1 ? (
            <IconButton
              alignSelf="center"
              colorScheme="error"
              variant="solid"
              style={[styles.btn, styles.btnCog]}
              onPress={this.toggleSpeakerGroupsCollapse}
              icon={
                <FontAwesomeIcon
                  icon={faLink}
                  size={12}
                  color={Theme.COLORS.PRIMARY}
                />
              }
            />
          ) : (
            <View style={styles.btn} />
          )}
        </HStack>
      );
    };
    if (this.props.isKioskMode) {
      return (
        <View>
          <HStack space="8">
            <View style={[{ flex: 1, justifyContent: "space-between" }]}>
              {/* title bar */}
              <RenderTitleBar />
              {/* seek bar */}
              <RenderSeekBar />
              {/* controls */}
              <RenderController />
            </View>
            <VStack
              alignItems="center"
              justifyContent="center"
              style={{
                width: 170,
              }}
            >
              <View
                style={{
                  width: "100%",
                  height: "100%",
                  padding: 10,
                  position: "relative",
                  minHeight: 100,
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    backgroundColor: Theme.COLORS.PRIMARY,
                    flex: 1,
                    width: 160,
                    height: 160,
                    borderRadius: 20,
                    top: -42,
                    position: "absolute",
                    justifyContent: "center",
                    alignItems: "center",

                    shadowColor: Theme.COLORS.PRIMARY,
                    shadowOffset: {
                      width: 0,
                      height: 3,
                    },
                    shadowOpacity: 0.2,
                    shadowRadius: 6.65,
                    elevation: 4,
                  }}
                >
                  <RenderCoverImg />
                </View>
                {/* <Image style={{ width: 150, height: 90 }} source={audioPlaying} /> */}
              </View>
            </VStack>
          </HStack>
          <View style={{ width: "100%", alignItems: "flex-end" }}>
            <HStack space="3" w="40%" ml="50px">
              {/* === todo: toggle group speakers === */}
              {this.props?.allSpeakers?.length > 1 &&
              this.props?.allSpeakers?.length -
                this.props?.slavesList?.length !==
                1 ? (
                <IconButton
                  alignSelf="center"
                  colorScheme="error"
                  variant="solid"
                  style={[styles.btn, styles.btnCog]}
                  onPress={this.toggleSpeakerGroupsCollapse}
                  icon={
                    <FontAwesomeIcon
                      icon={faLink}
                      size={12}
                      color={Theme.COLORS.PRIMARY}
                    />
                  }
                />
              ) : (
                <View style={styles.btn} />
              )}
              {/* volume and list */}
              <HStack space="2" w="full" justifyContent="center">
                <HStack
                  space="4"
                  alignItems="center"
                  style={[
                    {
                      width: "100%",
                    },
                  ]}
                >
                  {/* === volume slider ==== */}

                  <VolumeSlider
                    volume={this.state.volume}
                    isMuted={this.props.isMuted}
                    onVolumeChange={(v) => {
                      this.handleOnVolumeChange(
                        v,
                        this.props.smartSpeakerDeviceId,
                        this.props.smartSpeakerDeviceUId,
                        true
                      );
                    }}
                  />

                  {/* === Mute === */}
                  <TouchableOpacity
                    style={[
                      styles.listButton,
                      {
                        backgroundColor: !this.props.isMuted
                          ? "transparent"
                          : Theme.COLORS.BACKGROUND,
                      },
                    ]}
                    onPress={() => {
                      this.handleOnToggleMute(
                        true,
                        this.props?.slavesList?.length > 0
                      );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faVolumeMute}
                      size={16}
                      lite
                      color={
                        !this.props.isMuted
                          ? Theme.COLORS.BLACK
                          : Theme.COLORS.ERROR
                      }
                    />
                  </TouchableOpacity>
                  {/* === UnMute === */}
                  <TouchableOpacity
                    style={[
                      styles.listButton,
                      {
                        backgroundColor: this.props.isMuted
                          ? "transparent"
                          : Theme.COLORS.BACKGROUND,
                      },
                    ]}
                    onPress={() => {
                      if (this.state.isMuted)
                        this.handleOnToggleMute(
                          false,
                          this.props?.slavesList?.length > 0
                        );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faVolume}
                      size={16}
                      lite
                      color={
                        this.props.isMuted
                          ? Theme.COLORS.BLACK
                          : Theme.COLORS.ACTIVE
                      }
                    />
                  </TouchableOpacity>
                </HStack>
              </HStack>
            </HStack>
          </View>
        </View>
      );
    }
    return (
      <VStack space="3" mb="3" px="3">
        <HStack space="10px" justifyContent="space-between" w="full" mb="4">
          {/* title bar */}
          <RenderTitleBar />
          <View style={{ width: 100, height: "100%", position: "relative" }}>
            <View
              style={{
                backgroundColor: Theme.COLORS.PRIMARY,
                // flex: 1,
                width: 100,
                height: 100,
                borderRadius: 20,
                top: -42,

                // right: 0,
                position: "absolute",
                justifyContent: "center",
                alignItems: "center",

                shadowColor: Theme.COLORS.PRIMARY,
                shadowOffset: {
                  width: 0,
                  height: 3,
                },
                shadowOpacity: 0.2,
                shadowRadius: 6.65,
                elevation: 4,
              }}
            >
              <RenderCoverImg />
            </View>
          </View>
        </HStack>
        <View>
          {/* === seek bar === */}
          <RenderSeekBar />
          {/* === Controller === */}
          <RenderController />
          {/* === volume === */}
          <HStack space="2" w="full" justifyContent="center">
            <HStack
              space="4"
              alignItems="center"
              style={[
                {
                  width: "100%",
                },
              ]}
            >
              {/* === volume slider ==== */}

              <VolumeSlider
                volume={this.state.volume}
                isMuted={this.props.isMuted}
                onVolumeChange={(v) => {
                  this.handleOnVolumeChange(
                    v,
                    this.props.smartSpeakerDeviceId,
                    this.props.smartSpeakerDeviceUId,
                    true
                  );
                }}
              />

              {/* === Mute === */}
              {/* === UnMute === */}
              <TouchableOpacity
                style={[
                  styles.listButton,
                  {
                    backgroundColor: this.props.isMuted
                      ? "transparent"
                      : Theme.COLORS.BACKGROUND,
                  },
                ]}
                onPress={() => {
                  if (this.state.isMuted)
                    this.handleOnToggleMute(
                      false,
                      this.props?.slavesList?.length > 0
                    );
                }}
              >
                <FontAwesomeIcon
                  icon={faVolume}
                  size={16}
                  lite
                  color={
                    this.props.isMuted
                      ? Theme.COLORS.BLACK
                      : Theme.COLORS.ACTIVE
                  }
                />
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.listButton,
                  {
                    backgroundColor: !this.props.isMuted
                      ? "transparent"
                      : Theme.COLORS.BACKGROUND,
                  },
                ]}
                onPress={() => {
                  this.handleOnToggleMute(
                    true,
                    this.props?.slavesList?.length > 0
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faVolumeMute}
                  size={16}
                  lite
                  color={
                    !this.props.isMuted
                      ? Theme.COLORS.BLACK
                      : Theme.COLORS.ERROR
                  }
                />
              </TouchableOpacity>
            </HStack>
          </HStack>
        </View>
      </VStack>
    );
  };
  render() {
    var containerStyle = [
      styles.container,
      this.props.style || {},
      { paddingBottom: 0 },
    ];

    return (
      <View
        style={[
          containerStyle,
          {
            flexDirection: "column",
            // maxHeight: 180,
            shadowColor: Theme.COLORS.MUTED,
            shadowOffset: {
              width: 0,
              height: 3,
            },
            shadowOpacity: 0.2,
            shadowRadius: 6.65,
            elevation: 4,
            marginTop: 30,
          },
        ]}
      >
        {this.renderMediaContent()}
        {this.renderSlavesGroup()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    padding: 20,
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
  },
  controlsContainer: {
    // flexDirection: IsRTL ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: 210,
    padding: 12,
  },
  closeButton: {
    width: 30,
    height: 30,
    borderRadius: 8,
    // position: "absolute",
    // start: 5,
    // top: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  listButton: {
    //backgroundColor: "#ffffff50",
    width: 22,
    height: 22,
    borderRadius: 3,
    alignItems: "center",
    justifyContent: "center",
    padding: 1,
    borderRadius: 3,
  },
  slider: {
    marginEnd: 0,
    // writingDirection: "ltr",
    flex: 1,
    height: 15,
    // marginHorizontal: 8,
  },
  time: { fontSize: 10 },
  quickSeekWrapper: { flexDirection: "row", alignItems: "baseline" },
  quickSeekTime: { fontSize: 10, color: Theme.COLORS.BLACK },

  btnRemove: {
    backgroundColor: "#fee6eb",
    borderRadius: 10,
    padding: 1,
    width: 40,
    height: 40,
    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  btnChangeInput: {
    backgroundColor: Theme.COLORS.TL_PURPLE,
    borderRadius: 10,
    padding: 1,
    width: 30,
    height: 30,
    shadowColor: Theme.COLORS.TL_PURPLE,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
    // position: "absolute",
    // top: 10,
    // start: 10,
  },
  btn: {
    width: 35,
    height: 35,
  },
  btnCog: {
    backgroundColor: "#ffff",
    borderRadius: 10,
    padding: 1,

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  btnMenu: {
    backgroundColor: Theme.COLORS.BORDER,
    width: 80,
    height: 25,
    marginBottom: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  inputMenu: {
    width: 90,
    justifyContent: "space-between",
    alignItems: "center",
    position: "absolute",
    top: 10,
    start: 10,
    backgroundColor: Theme.COLORS.INPUT + "f0",
    padding: 5,
    borderRadius: 10,
  },
  btnVolumePlus: {
    backgroundColor: Theme.COLORS.BACKGROUND,
    padding: 5,
    borderRadius: 5,
    marginHorizontal: 5,
  },
});

export default MediaPlayer;
